import { Helmet } from "react-helmet-async";

const SITE_URL = "https://risorice.it";
const DEFAULT_IMAGE =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_risorice-ai-kitchen/artifacts/lsuoyrps_icon_cream_1024.png";

export const Seo = ({ title, description, path = "/", image = DEFAULT_IMAGE, lang = "it", jsonLd = null }) => {
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet prioritizeSeoTags>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="RISORICE" />
      <meta property="og:locale" content={lang === "it" ? "it_IT" : lang === "ru" ? "ru_RU" : "en_US"} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};
